import React, { createContext, useContext } from 'react';
interface PlaybackValue {
  paused: boolean;
}
const PlaybackContext = createContext<PlaybackValue>({
  paused: false
});
export function PlaybackProvider({
  paused,
  children
}: {
  paused: boolean;
  children: React.ReactNode;
}) {
  return <PlaybackContext.Provider value={{
    paused
  }} data-id="element-131" data-mp="2lcqaeuabeyxm">
      {children}
    </PlaybackContext.Provider>;
}
export function usePaused(): boolean {
  return useContext(PlaybackContext).paused;
}